import React, { FC, useContext } from 'react';
import Link from '@loomstateorg/shared-frontend/components/commercetools-ui/atoms/link';
import Typography from '@loomstateorg/shared-frontend/components/commercetools-ui/atoms/typography';
import { IconsContext } from 'context/icons';
import { useFormat } from '@loomstateorg/shared-frontend/hooks/useFormat';
import { Category } from 'types/category';
import MobileMenuNavButton from '../components/menu-nav-button';

export interface Props {
  links: Category[];
  hideHeaderMenu: () => void;
  categoriesNavigator?: Category[]; //This is a navigator where you push a subcategory to show it's contents
  insertCategory: (category: Category) => void;
  accountSubCategories?: Category[];
}

const MobileMenu: FC<Props> = ({
  links,
  categoriesNavigator,
  insertCategory,
  hideHeaderMenu,
  accountSubCategories,
}) => {
  const { formatMessage } = useFormat({ name: 'common' });
  const { icons, shouldShowIcons } = useContext(IconsContext);

  const isMyAccountMenu =
    categoriesNavigator && categoriesNavigator[categoriesNavigator.length - 1]?.categoryId === 'myAccount';

  return (
    <div className="ml-24 mr-22" data-testid="mobile-nav-list">
      {categoriesNavigator && categoriesNavigator?.length > 0 && (
        <div className="pt-24">
          {categoriesNavigator[categoriesNavigator.length - 1]?.categoryId != 'myAccount' && (
            // testid-ignore: only closes the drawer when the inner link is clicked
            <div className="pb-36" onClick={hideHeaderMenu}>
              <Link
                link={
                  categoriesNavigator[categoriesNavigator.length - 1]?.path ??
                  categoriesNavigator[categoriesNavigator.length - 1]?.slug
                }
                data-testid="view-all"
              >
                <Typography fontSize={24} className="text-primary-regular">
                  {formatMessage({ id: 'categories', defaultMessage: 'Categories' })}
                </Typography>
              </Link>
            </div>
          )}
        </div>
      )}
      {categoriesNavigator && categoriesNavigator.length <= 0 ? (
        links?.map((link, index) => (
          <MobileMenuNavButton
            key={index}
            categoriesNavigator={categoriesNavigator}
            link={link}
            onClick={() => insertCategory(link)}
            hideHeaderMenu={hideHeaderMenu}
            index={index}
          />
        ))
      ) : (
        <>
          {categoriesNavigator &&
            (isMyAccountMenu && accountSubCategories && accountSubCategories.length > 0
              ? accountSubCategories
              : categoriesNavigator[categoriesNavigator.length - 1].subCategories || []
            ).map((nav, index) => {
              const icon = icons.find((icon: any) => nav.key === icon?.key);
              return (
                <MobileMenuNavButton
                  key={nav.categoryId}
                  categoriesNavigator={categoriesNavigator}
                  link={nav}
                  onClick={() => insertCategory(nav)}
                  hideHeaderMenu={hideHeaderMenu}
                  icon={isMyAccountMenu ? icon : undefined}
                  shouldShowIcon={isMyAccountMenu ? shouldShowIcons : false}
                  index={index}
                />
              );
            })}
        </>
      )}
    </div>
  );
};

export default MobileMenu;
